module.exports = __webpack_public_path__ + "img/m3status.41752eff.png";